import { SvgRectangleArea, FixedDimension, SingleNamedObject } from "../../../../web-graphics";
import { Label } from "./label";

export class LabelMarkGroup extends SvgRectangleArea {
  constructor(settings) {
    super(settings);
    this.markObjects = [];
    this.lastPosX = undefined;
  }

  addMark(data, settings) {
    this.tryRemoveMarks(settings.currPointIndex, settings.blockSize, settings.signalBufferLength);
    const labelWidth = 30;
    const labelHeight = 30;
    const labelX = settings.x;
    const labelY = 0;

    const markLabel = new Label(
      {
        location: {
          x: new FixedDimension(labelX),
          y: new FixedDimension(labelY)
        },
        size: {
          width: new FixedDimension(labelWidth),
          height: new FixedDimension(labelHeight)
        },
        parent: {
          ref: this
        },
        htmlObject: {
          parent: {
            ref: this.settings.htmlObject.ref
          },
          graphicParent: this
        },
        title: `${data}`,
        fontSize: 12,
        fontFamily: "",
        color: this.settings.color,
        isCentered: true
      }
    );
    if (this.correctLabelPosition(markLabel, labelX, labelY)) {
      this.markObjects.push({
        visCounter: settings.currPointIndex,
        object: markLabel
      });
      this.childItemsContainer.add(new SingleNamedObject(labelX.toString(), markLabel));
    } else {
      markLabel.removeObjectFromDom();
    }
  }

  clear() {
    for (let i = 0; i < this.markObjects.length; i++) {
      this.markObjects[i].object.removeObjectFromDom();
    }
    this.markObjects = [];
    this.childItemsContainer.clear();
  }

  tryRemoveMarks(currPointCounter, blockSize, signalBufferLength) {
    while (
      this.markObjects.length > 0 &&
      this._isNeedRemoveMarks(this.markObjects[0].visCounter, currPointCounter, blockSize, signalBufferLength)
    ) {
      this.markObjects[0].object.removeObjectFromDom();
      this.childItemsContainer.remove(0);
      this.markObjects.shift(); // remove first element
    }
  }

  correctLabelPosition(markLabel, x, y) {
    const labelBorders = markLabel.getHtmlObjectRealBorders();
    let isNeedCorrect = false;
    let labelX = x;
    let labelY = y;
    const maxLabelWidth = Math.max(markLabel.settings.sizeInPixels.width, labelBorders.width);
    if (labelBorders.x < 0) {
      labelX = maxLabelWidth / 2;
      isNeedCorrect = true;
    } else if (labelBorders.x + labelBorders.width > this.settings.sizeInPixels.width) {
      labelX = this.settings.sizeInPixels.width - maxLabelWidth;
      isNeedCorrect = true;
    }
    if (this.settings.minXSpace !== undefined) {
      if (this.lastPosX === undefined) {
        this.lastPosX = labelX;
      } else {
        if (Math.abs(this.lastPosX - labelX) < this.settings.minXSpace) {
          return false;
        } else {
          this.lastPosX = labelX;
        }
      }
    }
    if (isNeedCorrect) {
      markLabel.setLocation(new FixedDimension(labelX), new FixedDimension(labelY));
      markLabel.createBorders();
    }
    return true;
  }

  _calcPosY(markLabel, y) {
    let resultY = y;
    const labelBorders = markLabel.getRealBorders();
    if (labelBorders.y < 0) {
      resultY = markLabel.getYFromReal(0, labelBorders.height);
    } else if (labelBorders.y + labelBorders.height > this.settings.htmlObject.sizeInPixels.height) {
      resultY = markLabel.getYFromReal(this.settings.htmlObject.sizeInPixels.height - labelBorders.height, labelBorders.height);
    }
    if (this.settings.minYSpace !== undefined) {
      if (this.lastPosY === undefined) {
        this.lastPosY = resultY;
      } else {
        const minY = this.lastPosY + this.settings.minYSpace;
        const currY = resultY + labelBorders.height / 4;
        if (minY > currY) {
          return undefined;
        } else {
          this.lastPosY = resultY;
        }
      }
    }
    return resultY;
  }

  _isNeedRemoveMarks(visCounter, currPointCounter, pointBlockSize, signalBufferLength) {
    if (currPointCounter - pointBlockSize < 0) {
      if ((visCounter >= signalBufferLength - pointBlockSize + currPointCounter) || (visCounter <= currPointCounter)) {
        return true;
      }
    } else {
      if ((visCounter <= currPointCounter) && (visCounter > currPointCounter - pointBlockSize)) {
        return true;
      }
    }
    return false;
  }
}
